import { RenderPaymentStatus, RenderSubscriptionStatus } from '@/components/features/shared/utils'
import { Collector } from '@/domain/collectors/collector'
import { PaymentSource } from '@/domain/payments/payments'
import { PaymentRow } from './PaymentRow'

export const StatusCell = ({ row, collectors }: { row: PaymentRow; collectors: Collector[] }) => {
  const collector = collectors?.find(c => c.id === row.collectorId)
  if (row.__source === PaymentSource.Subscription) {
    return (
      <RenderSubscriptionStatus
        paymentStatus={row.status}
        subscriptionStatus={row.__context.periodStatus!}
        amount={row.amount}
        collectorCode={collector?.code}
      />
    )
  }
  return <RenderPaymentStatus paymentStatus={row.status} collectorCode={collector?.code} />
}
